/* eslint-disable no-plusplus */
import DOMReady from '../utils/DOMReady'
import { inViewPort } from '../utils/inViewPort'

// Include css for webpack (for development only)
const css = require('../../css/blocks/timeline.scss') // eslint-disable-line no-unused-vars

class Timeline {
  constructor(el) {
    this.container = el
    this.init = this.init.bind(this)
    this.years = this.container.querySelectorAll('.timeline__card__counter')

    inViewPort(this.container, this.init, {
      rootMargin: '0px 0px -5% 0px',
      threshold: 0,
    })
  }

  init() {
    this.years.forEach(yearEl => {
      let currentNum = 0
      const { year } = yearEl.dataset
      const timer = 4000 / Number(year)
      const max = Number(year)

      const aboutStatsInterval = setInterval(() => {
        const yearText = String(currentNum).length < 2 ? `0${currentNum}` : currentNum
        yearEl.textContent = `${yearText}`
        if (currentNum === max) {
          clearInterval(aboutStatsInterval)
        }
        currentNum++
      }, timer)
    })
  }
}

DOMReady(() => {
  const wrapperEl = document.querySelectorAll('.timeline')
  Array.from(wrapperEl).forEach(el => {
    // eslint-disable-next-line no-new
    new Timeline(el)
  })
})
